<div class="call-details">
  <h1>Call Details</h1>
  <div class="table-container">
    <table>
      <thead>
        <tr>
          <th>Session ID</th>
          <th>Duration (minutes)</th>
          <th>Call Type</th>
          <th>Call Summary</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="record in callRecords" :key="record.session_id">
          <td>{{ record.session_id }}</td>
          <td>{{ calculateDuration(record.start_time, record.end_time) }}</td>
          <td>{{ record.call_type }}</td>
          <td>{{ record.call_summary }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
